import React from 'react'

interface TooltipProps {
  textTooltip: string
}

const Tooltip: React.FC<TooltipProps> = ({ textTooltip, children }) => {
  return (
    <div className="tooltip">
      <span className="tooltiptext">{textTooltip}</span>
      {children}
    </div>
  )
}

export default Tooltip
